// JavaScript be low IQ sometimes...
export default function isObject(v: unknown): v is object {
  return v !== null && typeof v === "object";
}
